<template>
  <div class="home-page">
    <section class="hero-section">
      <!--<img class="hero-image" src="/uvodni_2.jpg" alt="Hokejista" /> -->
      <img class="hero-image" src="/uvodni_high.png" alt="Hokejista" />
      <div class="hero-content">
        <!-- <img class="hero-logo" src="/logo.png" alt="NHL Logo" /> -->
        <div class="hero-headline">
          <h1 class="hero-title">NOČNÍ HOKEJOVÁ LIGA</h1>
          <p class="hero-subtitle">TAM, KDE LED ŽIJE NOCÍ</p>
        </div>
        <router-link to="/schedule" class="hero-btn">ZOBRAZIT ROZPIS</router-link>
      </div>
    </section>

    <div class="row intro-two-col g-4">
      <div class="col-md-6">
        <div class="jumbotron custom-jumbotron about-league-block h-100">
          <h2 class="section-title section-title--flush">O naší lize</h2>
          <p class="about-league-block__text">
            Noční hokejová liga je amatérská hokejová soutěž, kterou hrají týmy z Moravskoslezského kraje. Naším cílem je
            poskytnout hráčům možnost hrát hokej v přátelském a férovém prostředí.
          </p>
          <p class="about-league-block__text">
            Soutěž je organizována s důrazem na fair play a sportovní chování. Věříme, že hokej je více než
            jen sport – je to způsob života, který učí týmové spolupráci, respektu a fair play.
          </p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="jumbotron custom-jumbotron why-join-block h-100">
          <h2 class="section-title section-title--flush">Proč se zapojit?</h2>
          <ul class="list-group why-join-block__list">
            <li class="list-group-item">
              <i class="bi bi-trophy"></i> Pravidelná soutěž s profesionálním zázemím
            </li>
            <li class="list-group-item">
              <i class="bi bi-people"></i> Komunitní prostředí a nová přátelství
            </li>
            <li class="list-group-item">
              <i class="bi bi-calendar-event"></i> Pravidelné zápasy a turnaje
            </li>
            <li class="list-group-item">
              <i class="bi bi-star"></i> Možnost rozvoje pro hráče všech úrovní
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Aktuality -->
    <section class="news-section">
      <h2 class="section-title">Aktuality</h2>
      <p v-if="newsLoading" class="news-section__status">Načítání aktualit…</p>
      <p v-else-if="newsError" class="news-section__status news-section__status--error">{{ newsError }}</p>
      <p v-else-if="articles.length === 0" class="news-section__status">Zatím žádné aktuality.</p>
      <template v-else>
        <div class="news-grid">
          <article
            v-for="article in visibleArticles"
            :key="article.id"
            class="news-card"
            @click="openArticle(article)"
          >
            <div v-if="article.image" class="news-card__image-wrap">
              <img :src="article.image" :alt="article.title" class="news-card__image" />
            </div>
            <div class="news-card__body">
              <div class="news-card__date">{{ formatDate(article.date) }}</div>
              <h3 class="news-card__title">{{ article.title }}</h3>
              <p class="news-card__excerpt">{{ article.excerpt }}</p>
              <span class="news-card__link">Číst více <i class="bi bi-arrow-right"></i></span>
            </div>
          </article>
        </div>
        <div v-if="hasMoreArticles" class="news-section__more">
          <button
            v-if="!newsExpanded"
            type="button"
            class="news-more-btn"
            @click="newsExpanded = true"
          >
            Další zprávy
            <i class="bi bi-chevron-down ms-1"></i>
          </button>
          <button
            v-else
            type="button"
            class="news-more-btn news-more-btn--muted"
            @click="newsExpanded = false"
          >
            Zobrazit méně
            <i class="bi bi-chevron-up ms-1"></i>
          </button>
        </div>
      </template>
    </section>

    <!-- Article Detail Modal -->
    <div v-if="selectedArticle" class="article-modal-overlay" @click.self="selectedArticle = null">
      <div class="article-modal">
        <button class="article-modal__close" @click="selectedArticle = null">&times;</button>
        <div v-if="selectedArticle.image" class="article-modal__image-wrap">
          <img :src="selectedArticle.image" :alt="selectedArticle.title" class="article-modal__image" />
        </div>
        <div class="article-modal__content">
          <div class="article-modal__meta">
            <span>{{ formatDate(selectedArticle.date) }}</span>
            <span v-if="selectedArticle.author"> · {{ selectedArticle.author }}</span>
          </div>
          <h2 class="article-modal__title">{{ selectedArticle.title }}</h2>
          <div class="article-modal__body" v-html="selectedArticle.content"></div>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-12">
        <h2 class="section-title">Kontakt</h2>
        <p>
          Máte zájem o další informace nebo se chcete zapojit do naší ligy? Neváhejte nás kontaktovat!
        </p>
        <div class="card">
          <div class="card-body d-flex align-items-center">
            <div class="flex-grow-1">
              <h5 class="card-title">Kontaktní informace</h5>
              <p class="card-text">
                Email: l.klesnil@gmail.com<br>
                Telefon: +420 773 477 027<br>
                Zodpovědná osoba: Lukáš Klesnil
              </p>
            </div>
            <div class="ms-4">
              <img class="hero-logo" src="/logo.png" alt="NHL Logo" style="max-width: 200px; height: auto;" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

const NEWS_HOME_PREVIEW = 3;

export default {
  name: 'HomePage',
  data() {
    return {
      selectedArticle: null,
      articles: [],
      newsLoading: true,
      newsError: '',
      newsExpanded: false
    }
  },
  computed: {
    visibleArticles() {
      if (!this.articles.length) return [];
      if (this.newsExpanded || this.articles.length <= NEWS_HOME_PREVIEW) {
        return this.articles;
      }
      return this.articles.slice(0, NEWS_HOME_PREVIEW);
    },
    hasMoreArticles() {
      return this.articles.length > NEWS_HOME_PREVIEW;
    }
  },
  mounted() {
    this.loadNews();
  },
  methods: {
    mapArticleRow(row) {
      const fromDb =
        row.has_uploaded_cover && row.id != null
          ? `/api/news/${row.id}/cover`
          : null;
      return {
        id: row.id,
        title: row.title,
        excerpt: row.excerpt || '',
        content: row.content,
        image: fromDb || row.cover_image || null,
        date: row.published_at,
        author: row.author || ''
      };
    },
    async loadNews() {
      this.newsLoading = true;
      this.newsError = '';
      try {
        const { data } = await axios.get('/api/news');
        this.articles = Array.isArray(data) ? data.map((row) => this.mapArticleRow(row)) : [];
        this.newsExpanded = false;
      } catch (e) {
        console.error('Failed to load news', e);
        this.articles = [];
        this.newsError = 'Aktuality se nepodařilo načíst.';
      } finally {
        this.newsLoading = false;
      }
    },
    openArticle(article) {
      this.selectedArticle = article;
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleDateString('cs-CZ', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });
    }
  }
}
</script>

<style scoped>
.home-page {
  max-width: 1200px;
  margin: 0 auto;
  background: #0a1023;
  color: #e0e6f7;
  min-height: 100vh;
  padding: 0 1rem 3rem;
}

.hero-section {
  position: relative;
  background: linear-gradient(180deg, #0a1023 60%, #12204d 100%);
  border-radius: 1rem;
  overflow: hidden;
  margin-bottom: 2.5rem;
  height: 580px;
  width: 100%;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center center;
  /*filter: brightness(0.5) blur(1px); */
  filter: brightness(0.9);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background: #0a1023;
}

.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2.75rem 1.5rem 2rem;
  box-sizing: border-box;
}


.hero-headline {
  width: 100%;
  margin-top: 0;
}

.hero-logo {
  width: 120px;
  height: auto;
  filter: drop-shadow(0 0 12px rgba(31, 224, 255, 0.3));
}

.hero-title {
  font-size: 3rem;
  font-weight: 900;
  color: #1fe0ff;
  text-shadow: 0 0 16px #1fe0ff, 0 0 32px #0a1023;
  letter-spacing: 2px;
  margin-bottom: 0.5rem;
}

.hero-subtitle {
  font-size: 1.3rem;
  color: #a3eaff;
  text-shadow: 0 0 8px #1fe0ff;
  margin-bottom: 1.5rem;
  font-weight: 600;
}

.hero-btn {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(90deg, #1fe0ff 0%, #0a7cff 100%);
  color: #0a1023;
  font-weight: bold;
  border: none;
  border-radius: 2rem;
  padding: 0.8rem 2.2rem;
  font-size: 1.1rem;
  box-shadow: 0 0 16px #1fe0ff;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.hero-btn:hover {
  transform: translateX(-50%) translateY(-1px);
  background: linear-gradient(90deg, #0a7cff 0%, #1fe0ff 100%);
  color: #fff;
}

.custom-jumbotron {
  background: #151d3a;
  border-radius: 0.75rem;
  color: #e0e6f7;
  border: 1px solid rgba(31, 224, 255, 0.08);
  margin-bottom: 2rem;
  padding: 1.25rem 1.5rem;
}

.about-league-block__text {
  font-size: 1rem;
  color: #e0e6f7;
  line-height: 1.65;
  margin-bottom: 0.85rem;
}

.about-league-block__text:last-of-type {
  margin-bottom: 0;
}

.section-title--flush {
  margin-top: 0;
}

.intro-two-col {
  margin-bottom: 0;
}

.intro-two-col .custom-jumbotron {
  margin-bottom: 0;
}

.why-join-block__list {
  margin-bottom: 0;
}

.section-title {
  background: linear-gradient(135deg, #1fe0ff, #0a7cff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
  letter-spacing: -0.02em;
  font-size: 1.75rem;
  margin-top: 2.5rem;
  margin-bottom: 1.2rem;
}

.list-group-item {
  background: #151d3a;
  color: #e0e6f7;
  border: 1px solid rgba(31, 224, 255, 0.06);
  margin-bottom: 0.5rem;
  border-radius: 0.75rem;
  font-weight: 500;
  font-size: 1.05rem;
  padding: 0.9rem 1.2rem;
  transition: all 0.25s ease;
}

.list-group-item:hover {
  border-color: rgba(31, 224, 255, 0.12);
  background: #1a2444;
}

.list-group-item i {
  margin-right: 0.5rem;
  color: #1fe0ff;
}

.card {
  background: #151d3a;
  color: #e0e6f7;
  border: 1px solid rgba(31, 224, 255, 0.08);
  border-radius: 0.75rem;
  margin-top: 1rem;
  padding: 1.2rem 1.2rem 0.7rem 1.2rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.card:hover {
  transform: translateY(-2px);
  border-color: rgba(31, 224, 255, 0.15);
  box-shadow: 0 8px 24px rgba(10, 16, 35, 0.4);
}

.card-title {
  color: #1fe0ff;
  font-weight: 700;
}

.row.mt-5 {
  margin-top: 2.5rem !important;
}

/* ---- Aktuality Section ---- */
.news-section {
  margin-top: 3rem;
  margin-bottom: 2rem;
}

.news-section__status {
  color: #8892b0;
  font-size: 0.95rem;
  margin: 0 0 1rem 0;
}

.news-section__status--error {
  color: #ff4d6a;
}

.news-section__more {
  display: flex;
  justify-content: center;
  margin-top: 1.75rem;
}

.news-more-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.65rem 1.75rem;
  font-size: 0.95rem;
  font-weight: 600;
  color: #0a1023;
  background: linear-gradient(135deg, #1fe0ff 0%, #0a7cff 100%);
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 12px rgba(31, 224, 255, 0.2);
}

.news-more-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(31, 224, 255, 0.35);
  color: #0a1023;
}

.news-more-btn--muted {
  background: transparent;
  color: #8892b0;
  border: 1px solid rgba(31, 224, 255, 0.25);
  box-shadow: none;
}

.news-more-btn--muted:hover {
  color: #1fe0ff;
  border-color: rgba(31, 224, 255, 0.45);
  box-shadow: 0 0 16px rgba(31, 224, 255, 0.12);
}

.news-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.news-card {
  background: #151d3a;
  border: 1px solid rgba(31, 224, 255, 0.08);
  border-radius: 0.75rem;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
}

.news-card:hover {
  transform: translateY(-4px);
  border-color: rgba(31, 224, 255, 0.2);
  box-shadow: 0 8px 32px rgba(10, 16, 35, 0.5), 0 0 20px rgba(31, 224, 255, 0.06);
}

.news-card__image-wrap {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.news-card__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.35s ease;
}

.news-card:hover .news-card__image {
  transform: scale(1.05);
}

.news-card__body {
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.news-card__date {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #8892b0;
  margin-bottom: 0.5rem;
}

.news-card__title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #e0e6f7;
  margin-bottom: 0.6rem;
  line-height: 1.3;
}

.news-card__excerpt {
  font-size: 0.92rem;
  color: #8892b0;
  line-height: 1.55;
  margin-bottom: 1rem;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-card__link {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1fe0ff;
  transition: color 0.2s ease;
}

.news-card:hover .news-card__link {
  color: #0a7cff;
}

.news-card__link i {
  transition: transform 0.2s ease;
}

.news-card:hover .news-card__link i {
  transform: translateX(3px);
}

/* ---- Article Detail Modal ---- */
.article-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 16, 35, 0.85);
  backdrop-filter: blur(8px);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.article-modal {
  background: #151d3a;
  border: 1px solid rgba(31, 224, 255, 0.1);
  border-radius: 1rem;
  max-width: 700px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.4);
}

.article-modal__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(10, 16, 35, 0.6);
  border: 1px solid rgba(31, 224, 255, 0.15);
  color: #e0e6f7;
  font-size: 1.5rem;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 2;
  line-height: 1;
}

.article-modal__close:hover {
  background: rgba(31, 224, 255, 0.15);
  color: #1fe0ff;
}

.article-modal__image-wrap {
  width: 100%;
  max-height: 350px;
  overflow: hidden;
  border-radius: 1rem 1rem 0 0;
}

.article-modal__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.article-modal__content {
  padding: 1.75rem;
}

.article-modal__meta {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #8892b0;
  margin-bottom: 0.75rem;
}

.article-modal__title {
  font-size: 1.6rem;
  font-weight: 800;
  color: #e0e6f7;
  letter-spacing: -0.02em;
  line-height: 1.2;
  margin-bottom: 1.25rem;
}

.article-modal__body {
  font-size: 1rem;
  color: #c0c8e0;
  line-height: 1.7;
}

.article-modal__body p {
  margin-bottom: 1rem;
}

.article-modal__body p:last-child {
  margin-bottom: 0;
}

@media (max-width: 991px) {
  .news-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .hero-section {
    height: 350px;
  }

  .hero-content {
    padding: 1.75rem 1rem 1.5rem;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .hero-btn {
    bottom: 1.25rem;
    padding: 0.55rem 1.35rem;
    font-size: 0.92rem;
    border-radius: 1.2rem;
    box-shadow: 0 0 10px rgba(31, 224, 255, 0.55);
  }

  .news-grid {
    grid-template-columns: 1fr;
  }

  .article-modal-overlay {
    padding: 1rem;
  }

  .article-modal {
    max-height: 90vh;
  }

  .article-modal__title {
    font-size: 1.3rem;
  }
}
</style> 